import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { fmtDateTime, relativeTime } from "@/lib/format";

export default function Updates() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/customer/updates").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-8" data-testid="customer-updates-page">
      <PageHeader eyebrow="Timeline" title="Project updates" description="Progress, milestones, and site imagery from your builder." />

      <div className="timeline">
        {items.map((u) => (
          <article key={u.id} className="relative pb-8" data-testid={`update-${u.id}`}>
            <div className="timeline-dot" />
            <div className="grid-surface">
              {u.images && u.images.length > 0 && (
                <div className="grid grid-cols-2 gap-0.5 bg-stone-200">
                  {u.images.slice(0, 2).map((src, i) => (
                    <img key={i} src={src} alt="" className="w-full h-48 object-cover" />
                  ))}
                </div>
              )}
              <div className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="overline text-brand-600">
                      {u.project?.name} {u.milestone && `· ${u.milestone}`}
                    </div>
                    <h3 className="font-display text-xl font-bold mt-1">{u.title}</h3>
                  </div>
                  <div className="text-xs text-stone-500 font-mono whitespace-nowrap">{relativeTime(u.created_at)}</div>
                </div>
                <p className="text-stone-700 mt-3 leading-relaxed">{u.body}</p>
                <div className="mt-3 text-xs text-stone-500 font-mono border-t border-stone-100 pt-2">
                  {u.author_name && <span>By {u.author_name} · </span>}{fmtDateTime(u.created_at)}
                  {u.progress != null && <span> · {u.progress}% project progress</span>}
                </div>
              </div>
            </div>
          </article>
        ))}
        {items.length === 0 && (
          <div className="grid-surface border-dashed p-10 text-center overline text-stone-400">
            No updates have been posted yet
          </div>
        )}
      </div>
    </div>
  );
}
